import { render, staticRenderFns } from "./AnimatedLargeCopyImg.vue?vue&type=template&id=da945418&scoped=true&"
import script from "./AnimatedLargeCopyImg.vue?vue&type=script&lang=js&"
export * from "./AnimatedLargeCopyImg.vue?vue&type=script&lang=js&"
import style0 from "./AnimatedLargeCopyImg.vue?vue&type=style&index=0&id=da945418&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da945418",
  null
  
)

export default component.exports